const state = {
  mauticData: {},
  hasData: false
};

const getters = {
  userData: state => state.mauticData,
  isSaved: state => state.hasData
};
const actions = {
  saveMauticData({ commit }, data) {
    commit("setMauticData", data);
  }
};
const mutations = {
  setMauticData: (state, data) => {
    state.mauticData = data;
    state.hasData = true;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
